export default __webpack_public_path__ + "static/media/huddle.65d72e1d.JPG";